module.exports = __webpack_public_path__ + "img/icon-games-played.ccbce914.png";